
export default {//改变state里定义的变量的方法,调用方法是this.$store.commit('方法名','要改变的数据')
    setUserInfo (state, obj) {
        state.userInfo = obj;
    },
    setIsLogin (state, boolean) {
        state.isLogin = boolean;
    },
    setShowLogin (state, boolean) {
        state.show_login_compoments = boolean;
    },
    setShowUserInfo (state, boolean) {
        state.show_userinfo_compoments = boolean;
    },
    setShowCodeExchange (state, boolean) {
        state.show_code_exchange_compoments = boolean;
    },
    setShowBindPhone (state, boolean) {
        state.show_bindphone_compoments = boolean;
    },
    setShowAttenDance (state, boolean) {
        state.show_attendance_compoments = boolean;
    },
    setShowOpen (state, boolean) {
        state.show_open_compoments = boolean;
    },
    setShowQuestion (state, boolean) {
        state.show_question_compoments = boolean;
    },
    setToastVip (state, boolean) {
        console.log("toastVip set")
        state.show_toast_vip = boolean;
    },
    setVideoType (state, type) {
        state.video_type = type;
    },
    setInviteCode (state, boolean) {
        state.shou_invite_code = boolean;
    },
    videoPlayUrl(state,data){
        state.video_play_url = data
    },
    showVideoPop(state,data){
        state.show_video_pop = data
    },
    showVipTime(state,data){
        state.show_vip_time = data
    },
    kekePopSet(state,data){
        state.kekePop = data
    },
    checkoutKePop(state){
        // state.kekePop = true
        let keTimer = null
        const vipForever = localStorage.getItem("vip_time") || 0 ;
        if(vipForever == 0){
            let kehuInfo2 = localStorage.getItem('payTip')
            if(kehuInfo2){
                kehuInfo2 = JSON.parse(kehuInfo2)
                let start_time2 = kehuInfo2
                const TWELVE_HOURS2 = 12 * 60 * 60 * 1000; // 12小时的毫秒数
                const currentTime2 = Date.now();
            
                // 计算时间差
                const timeDiff2 = currentTime2 - parseInt(start_time2, 10);
                if (timeDiff2 >= TWELVE_HOURS2) {//大于12个小时
                    
                }else{
                    return
                }
            }
        }else{
          console.log('!!!0')
          let kehuInfo = localStorage.getItem('vip_time')
          kehuInfo = JSON.parse(kehuInfo)
          let start_time = kehuInfo
          const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
          const currentTime = Date.now();
      
          // 计算时间差
          const timeDiff = currentTime - parseInt(start_time, 10);
      
          // 超过12小时执行操作
          if (timeDiff >= TWELVE_HOURS) {
            console.log(1111)
            state.kekePop = true
            localStorage.setItem('vip_time',Date.now())
            return
         }

        }
        // if(!localStorage.getItem('payTip')) return
        this.$http.post('/front/aimj/huodong/chongzhi/', {vip_type: 5, APP_ID: APP_ID}).then(res => {
            if(res.data.pay_url){
                state.kekePop = true
                localStorage.setItem('payTip',Date.now())
                clearInterval(keTimer)
            }else{
                // if(!localStorage.getItem('payTip')) return
                keTimer=setInterval(()=>{
                    this.$http.post('/front/aimj/huodong/chongzhi/', {vip_type: 5, APP_ID: APP_ID}).then(res => {
                        if(res.data.pay_url){
                            state.kekePop = true
                            localStorage.setItem('payTip',JSON.stringify({ time: Date.now() }))
                            clearInterval(keTimer)
                        }else{
                            let kehuInfo = localStorage.getItem('payTip')
                            kehuInfo = JSON.parse(kehuInfo)
                            let start_time = kehuInfo
                            const TWELVE_HOURS = 600000; // 十分钟的毫秒数
                            const currentTime = Date.now();
                        
                            // 计算时间差
                            const timeDiff = currentTime - parseInt(start_time, 10);
                            if (timeDiff >= TWELVE_HOURS) {
                                clearInterval(keTimer)
                            }
                        }
                    }).catch(res=>{
                        clearInterval(keTimer)
                    })
                },3000)
            }
        }).catch(res=>{
            clearInterval(keTimer)
        })

    },
    isADShowSet(state,data){
        state.isADShow = data
    },

    setisInputValshow (state, obj) {
        state.isInputValshow = obj;
    },
    setisInputtype (state, obj) {
        state.isInputtype = obj;
    },
    setisInputVal (state, obj) {
        state.isInputVal = obj;
    },
            setIsYouhuiPopshow(state, data){
            state.isYouhuiPopshow = data
        },
                set_type(state,data){
            state._type = data
        },
                setYouhuiPayDeail(state, data){
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    state.youhuiPayDeail[key] = data[key]
                  }
            }
            console.log(state.youhuiPayDeail);
        },
                setNewPayPop(state, data){
            state.newPayPop = data
        },
                setcomVipShow(state,data){
            state.comVipShow = data
        },
    /* 新版支付相关 */
    setFisYouh(state, boolean){
        state.fisYouh = boolean;
    },
    setSecYouh(state, boolean){
        state.secYouh = boolean;
    },
    setHeader_r_show(state, data) {
        state.header_r_show = data;
    },
    setVipYouhuiHeaderShow(state, data) {
		state.vip_youhui_header_show = data;
	},
    //恭喜你成为xxx弹窗
    setVipCongratulationsShow(state, data) {
		state.vip_congratulations_show = data;
	},
    //opt技术弹窗
    setIsOPTshow(state, data) {
		state.isOPTshow = data;
	},
        
}
